export default __webpack_public_path__ + "static/ecosystemaug-bcff530ffcc32ee24e94a8d7cade45a1.jpg";